// The chart inputs of an open-ended block, ported from the coffee block's calcChartProps.
//
// The old chart view was constructed with `model: @chartsModel`, so every model-derived prop came
// off the charts model -- including the ones it does not carry (type, sortOrder), which the chart
// legitimately receives as undefined. Reading the question instead changes qType / isTraitType and
// the chart stops resolving a config, so the question values are passed in deliberately.
//
// The combo family replaces this one; see cx/lib/props/chart.

import { getColorTheme, getFeatures, getModelValue } from '@aytm/app/stats/lib/stat-page'
import { isTraitType } from '@aytm/app/stats/page/components/lib/utils'
import PageGlobals from '@aytm/app/stats/lib/page/page-globals'

export const calcChartProps = ({
  questionId,
  questionKey,
  type,
  format,
  sortOrder,
  chartMode,
  questionChartMode,
  zoomLevel,
  handlers = {}
} = {}) => ({
  questionId,
  questionKey,
  qType: type,
  sortOrder,
  chartMode,
  questionChartMode,
  globalChartMode: getModelValue('chartMode'),
  zoomLevel,
  globalZoomLevel: getModelValue('zoomLevel'),
  zoomType: true,
  isTraitType: isTraitType({ format, type }),
  // the chart resolves its own config from the charts model, so the question's format is not it
  format: {},
  colorTheme: getColorTheme(),
  chartLegendMode: getModelValue('chartLegendMode'),
  confidenceLevel: getModelValue('confidenceLevel'),
  significanceLevel: getModelValue('significanceLevel'),
  confidenceLevels: PageGlobals.CONFIDENCE_LEVELS,
  features: getFeatures(),
  onChartModeChange: handlers.onChartModeChange,
  onZoomChange: handlers.onZoomChange,
  onChartReady: handlers.onChartReady
})
